export const getLabelFromUrl = (url: string) => {
  return url.split('/').pop() ?? ''
}
